const colorMap = {
  blue: "bg-blue-600",
  red: "bg-red-600",
  green: "bg-green-600",
  yellow: "bg-yellow-600",
}

export default function Announcement({ color = "blue", underlined_text, text }) {
  const bgColor = colorMap[color] || "bg-blue-600"

  return (
    <div className={`${bgColor} px-4 py-3 text-white`}>
      <p className="text-center text-sm font-medium">
        <strong className="underline">{underlined_text}</strong> {text}
      </p>
    </div>
  )
}
